export default __webpack_public_path__ + "static/buy-barcode@2x-8d16a446c0951a973944e21b2afc600d.jpg";